import { useLookupPlace } from "@/hooks/useLocationSearch";

const API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

export function GoogleMapPreview({
  placeId,
  className,
  zoom = 15,
}: {
  placeId?: string | null;
  className?: string;
  zoom?: number;
}) {
  const place = useLookupPlace(placeId);
  if (!placeId || !API_KEY || !place.data) return null;

  return (
    <div className={className}>
      <div className="relative h-48 overflow-hidden">
        <div className="absolute size-full bg-black/10 animate-pulse" />
        <gmp-map center={place.data.location!} zoom={zoom} mapId="DEMO_MAP_ID">
          <gmp-advanced-marker position={place.data.location!} title={place.data.displayName!} />
        </gmp-map>
      </div>
    </div>
  );
}
